var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFea4(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.238,
    height: 86.914,
    viewBox: "0 0 83.238 86.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021",
    transform: "translate(-1524.362 -5149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M42,78.5c10.1-1.6,16.7-7,22.3-12.4-4.2-.3-9,.8-15.4,3.4,7.8-10,7.2-15.6,8.2-20.9A46.741,46.741,0,0,0,41.5,63.9c1.6-7.2-1.2-20.8-5.1-27-3.9,6.2-6.7,19.8-5.1,27A44.939,44.939,0,0,0,15.7,48.6c1.1,5.3.5,10.9,8.2,20.9-6.4-2.6-11.2-3.7-15.4-3.4,5.6,5.4,12.1,10.8,22.3,12.4-4.2,0-7.9,2.1-11.4,6.7,4.6.2,8.5.7,16.8-6.5-.3,2.6-.9,7.7-.9,9.8h2.2c0-2.2-.6-7.2-.9-9.8,8.3,7.2,12.1,6.7,16.8,6.5C49.9,80.6,46.2,78.6,42,78.5Z",
    transform: "translate(1521 5147.414)",
    fill: "#ff8f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M86.6,60.4,71.7,46.8a12.777,12.777,0,0,0,1.4-2.1c.2-.4.2-.8,0-.9l-1.7-1.5,1.5-1.6a2.389,2.389,0,0,0,.5-1.4,1.612,1.612,0,0,0-.6-1.3L43,10.9l.2-.2a.935.935,0,0,0-.1-1.3L40.7,7.2a.935.935,0,0,0-1.3.1L35.2,12,29.9,7.2l2.6-2.8a.713.713,0,0,0-.1-1.1L30.7,1.8a.713.713,0,0,0-1.1.1L22,10.1a.713.713,0,0,0,.1,1.1l1.7,1.5a.713.713,0,0,0,1.1-.1l2.6-2.8,5.3,4.8-4.2,4.7a.935.935,0,0,0,.1,1.3l2.4,2.2a.935.935,0,0,0,1.3-.1l.2-.2,29.7,27a2.106,2.106,0,0,0,1.3.5h.1a1.612,1.612,0,0,0,1.3-.6l1.5-1.6,1.7,1.5a.647.647,0,0,0,.9-.1,14.012,14.012,0,0,0,2-1.6L84.6,60ZM36.5,18h0l1.2-1.3,4.2-4.6,2.5,2.3-6.2,6.8L40,22.8,46.2,16l2.7,2.5-6.2,6.8,1.8,1.6,6.2-6.8,2.7,2.5-6.2,6.8L49,31l6.2-6.8,2.7,2.5-6.2,6.8,1.8,1.6,6.2-6.8,2.7,2.5-6.2,6.8.9.8-2.2,2.4L33.6,21.3Z",
    transform: "translate(1521 5147.414)",
    fill: "#ff8f3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018",
    transform: "translate(1521 5147.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M25.8,25.1a6.952,6.952,0,0,0-2.4-4.4,6.461,6.461,0,0,0-8-.1A6.285,6.285,0,0,0,13,24.8Z",
    fill: "#ff8f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M13,26.3a6.952,6.952,0,0,0,2.4,4.4,6.461,6.461,0,0,0,8,.1,6.285,6.285,0,0,0,2.4-4.2Z",
    fill: "#ff8f3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    transform: "translate(1521 5147.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M30.3,41.4a6.254,6.254,0,0,0-.2-5A6.372,6.372,0,0,0,19,35.5Z",
    fill: "#ff8f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M18.3,36.9a6.254,6.254,0,0,0,.2,5,6.372,6.372,0,0,0,11.1.9Z",
    fill: "#ff8f3b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(1521 5147.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M15.1,36.5a6.147,6.147,0,0,0-4.2-2.7,6.377,6.377,0,0,0-7.1,8.6Z",
    fill: "#ff8f3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M4.5,43.7a6.147,6.147,0,0,0,4.2,2.7,6.377,6.377,0,0,0,7.1-8.6Z",
    fill: "#ff8f3b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFea4);
export default __webpack_public_path__ + "static/media/fea4.4d7ab3899f590cd7896e4c2cdfdbd613.svg";
export { ForwardRef as ReactComponent };